export default [
   
    {
        path: "gift-catalog",
        name: "GiftCatalog",
        meta:{
            permissionPath: 'gifts.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "giftCatalog" */ "@/views/loyaltyPanel/catalog/tabs/GiftCatalog.vue"
            )
    },
    {
        path: "catalog-categories",
        name: "CatalogCategories",
        meta:{
            permissionPath: 'gift_categories.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "catalogCategories" */ "@/views/loyaltyPanel/catalog/tabs/CatalogCategories.vue"
            )
    },
];
